import React from 'react';
import { FiLock } from "react-icons/fi";

const PaymentSection = () => (

  
  <div className="bg-white border border-[#E0E0E0] rounded-[12px] p-5 md:p-8 w-full max-w-[550px] mx-auto shadow-md font-inter animate-in fade-in duration-500">
   
    <h2 className="text-center text-[20px] mb-10 md:text-[24px] font-[500] tracking-tight text-[#000000] mb-2 font-inter mb-4">
      Payment Summary
    </h2>
    <div className="space-y-4 md:space-y-8 mb-8 md:mb-8 text-left">
      <div className="flex justify-between items-start gap-4 border-b border-black pb-2">
        <span className="text-[14px] md:text-[18px] font-[500] text-[#000000] tracking-tight leading-tight">
          Yearly Prime Subscription Plan
        </span>
        <span className="text-[14px] md:text-[18px] font-[500] text-[#000000] tracking-tight whitespace-nowrap">
          ₹799
        </span>
      </div>
      <div className="flex justify-between items-start gap-4 border-b border-black pb-2">
        <span className="text-[14px] md:text-[18px] font-[500] text-[#000000] tracking-tight leading-tight">Discount Applied</span>
        <span className="text-[14px] md:text-[18px] font-[500] tracking-tight whitespace-nowrap text-[#57F33C]">-₹170</span>
      </div>

      <div className="flex justify-between items-start gap-4 border-b border-black pb-2">
        <span className="text-[14px] md:text-[18px] font-[500] text-[#000000] tracking-tight leading-tight">GST (18%)</span>
        <span className="text-[14px] md:text-[18px] font-[500] tracking-tight whitespace-nowrap text-[#333]">₹113.22</span>
      </div>
      <div className="flex justify-between items-start gap-4 pb-2 mb-3">
        <span className="text-[18px] md:text-[22px] font-bold text-[#333]">Total to Pay</span>
        <span className="text-[18px] md:text-[22px] font-bold text-[#333]">₹742.22</span>
      </div>
    </div>
    <button className="w-full bg-[#4096F6] text-white py-3 md:py-3 rounded-[5px] tracking-tight font-[500] text-[16px] md:text-[22px] flex items-center justify-center gap-3 hover:shadow-lg transition-all mb-4 active:scale-95 cursor-pointer">
      <FiLock className="text-[24px]" /> Pay ₹742.22
    </button>
    <div className="flex items-center justify-center gap-2 text-[#000000] font-[500] text-[13px] md:text-[18px] tracking-tight">

      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.55281 7.74036C7.88769 6.99985 6.77861 6.80065 5.94529 7.47875C5.11197 8.15685 4.99465 9.29064 5.64906 10.0926C6.01852 10.5454 6.89637 11.3391 7.59077 11.9446C7.9201 12.2317 8.08472 12.3752 8.28393 12.4341C8.45378 12.4842 8.65185 12.4842 8.8217 12.4341C9.02091 12.3752 9.18553 12.2317 9.51486 11.9446C10.2093 11.3391 11.0871 10.5454 11.4565 10.0926C12.111 9.29064 12.008 8.14972 11.1604 7.47875C10.3127 6.80778 9.21794 6.99985 8.55281 7.74036Z" stroke="#21C11E" stroke-width="1.9009" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M7.94517 17.6927C8.1403 17.7944 8.23791 17.8452 8.37325 17.8715C8.47875 17.8921 8.63082 17.8921 8.73632 17.8715C8.87167 17.8452 8.96928 17.7944 9.16441 17.6927C10.9689 16.7524 16.1584 13.6799 16.1584 9.43988V5.84488C16.1584 5.08499 16.1584 4.70504 16.0341 4.37844C15.9243 4.08991 15.7459 3.83247 15.5143 3.62836C15.2521 3.39732 14.8964 3.26391 14.1849 2.99709L9.08875 1.08605C8.89115 1.01195 8.7924 0.974899 8.6907 0.960205C8.6006 0.947184 8.50898 0.947184 8.41887 0.960205C8.31718 0.974899 8.21842 1.01195 8.02082 1.08605L2.92469 2.99709C2.21318 3.26391 1.85743 3.39732 1.59526 3.62836C1.36365 3.83247 1.18524 4.08991 1.07545 4.37844C0.951172 4.70504 0.951172 5.08499 0.951172 5.84488V9.43988C0.951172 13.6799 6.1406 16.7524 7.94517 17.6927Z" stroke="#21C11E" stroke-width="1.9009" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      Secure Payment
    </div>
  </div>
);

export default PaymentSection;